import * as React from "react";
import { Button, Modal, notification } from "antd";
import { CopyOutlined, DownloadOutlined } from "@ant-design/icons";
import { Copy } from "react-feather";

interface Props {
  keyContent: string;
  keyPath: string;
  onDone: any;
  visible: boolean;
}

export const CreatedServiceAccountKeyModal: React.FC<Props> = ({ keyContent, keyPath, onDone, visible }) => {
  const [tookAction, setTookAction] = React.useState(false);

  async function copyToClipboard() {
    navigator.clipboard.writeText(keyContent);
    notification.success({
      message: "Copied to clipboard",
    });
    setTookAction(true);
  }

  function getHrefOfKey() {
    const file = new Blob([keyContent], { type: "text/txt" });
    return URL.createObjectURL(file);
  }

  return (
    <Modal
      title={"Service Account Key"}
      open={visible}
      maskClosable={false}
      destroyOnHidden
      footer={
        <div className="flex items-center justify-end gap-4">
          <Button type="default" icon={<DownloadOutlined size={20} />} onClick={() => setTookAction(true)}>
            <a href={getHrefOfKey()} download={`${keyPath}.txt`}>
              Download Key File
            </a>
          </Button>
          <Button type="primary" onClick={onDone} disabled={!tookAction}>
            Done
          </Button>
        </div>
      }
    >
      <div>
        <div>A new key has been created for this service account.</div>
        <div>Copy or download the generated key below.</div>
        <div>You will not be able to retrieve the key after you close this screen.</div>
        <div className="flex items-center mt-2">
          <input className="flex-grow h-8 px-4 py-2 border rounded" disabled={true} value={keyContent} />
          <CopyOutlined onClick={copyToClipboard} className="ml-2 color-link-hover" />
        </div>
      </div>
    </Modal>
  );
};
